module.exports = __webpack_public_path__ + "media/images/wedding/events/cocktail-31b3c844b3ab89de56e560d46a12901f.jpg";